const config = {
  set_title: 'setting layout',
  set_tip:
    'Users can modify the data to be displayed on this page through their usage habits',
  save_btn: 'Save',
  data_id: 'Application No',
  data_group: 'Group',
  date: 'Interview Date',
  data_address: 'Location',
  data_parents_info: 'Parents information',
  data_birth: 'Birth Certificate',
  data_receipt: 'Receipt',
  data_parents_contact: 'Parents contact',
  data_time: 'Interview Time',
  data_date: 'Date',
  data_rating: 'Rating',
  data_attendance: 'Attendance',
  table_title: 'Interview Information',
  table_btn: 'setting layout',
  table_search_student: 'Search',
  table_search_date: 'Interview Date',
  table_search_timeFrame: 'Interview Time',
  table_search_place: 'Location',
  data_name: 'Name',
  data_interview_no: 'Interview No',
  data_sex: 'Gender',
  data_operation: 'Actions',
  open_btn: 'VIEW',
  edit_btn: 'Edit',
  phase: 'Please select',
  Name_interview: 'Name of interview',
  group: 'Interview group',
  previous: 'Cancel',
  determine: 'OK',
  interview_system: 'Interview Information',
  NameofStudent: 'Name of Student',
  Confirm_attend: 'Confirm to attend',
  Application_number: 'Application No',
  interview_panel: 'Interview Time',
  interview_time: 'interview_time',
  select_time: 'Select time',
  returns: 'BACK',
  attendance: 'Attend',
  Parent_Contact_Number: 'Parent_Contact_Number',
  birth_certificate: 'birth_certificate',
  open: 'VIEW',
  receipt: 'Receipt',
  attend_time: 'Arrive Time',
  name: 'Name：',
  telephone: 'Mobile Tel.：',
  FATHER: 'Father',
  MOTHER: 'Mother',
  GUARDIAN: 'GuardIan',

  select_view_time: 'Choose interview time',
  selected: 'Selected',
  confirm_time: 'Confirm',

  not_info: 'No records',
  not_device: 'Cannot find device, please use photo album function',
  Cancel_attendance: 'Cancel Attend',
  Cancellation_succeeded: 'Cancellation succeeded',
  Cancel_failed: 'Cancel failed',
  Success_attend: 'Success attend',
  Attend_failed: 'Attend failed',
  location: 'Location',
  total_score: 'Total score',

  Scan_successfully: 'Successful, now going to profile page',
  Scan_loading: 'Scanning in progress, please wait...',
  Scan_failed: 'Scan fail, please try again',
  Scan_error: 'The QR code not in current phase',
  Invalid_token: 'Invalid token, please try again',
  Incorrect_QR_code: 'Incorrect QR code',
  employee: 'Is the {{value}} a PLK employee?',
  graduate: 'Is the {{value}} a PLK graduate?',
  WorkPlace: 'Work Place',
  NameEnglish: 'Name in English：',
  career: 'Occupation：',
  Yes: 'Yes',
  no: 'No',
  Parent: 'Parent',
  Setscore: 'Set score',
  Attend: 'Attend',
  not_found: 'No results',
  ConnectPrinter: 'Connect Printer',
  PrintLabel: 'Print Label',
  logout: 'Logout',
  preview: 'Preview',
  student_file: 'Student Files',
  Row: 'Row {{from}} to Row {{to}}, Total {{ value }} Rows ',
  Page: 'Rows per Page: ',
  attendance_status: 'Attendance status',
  not_present: 'Not attend',
};

export default config;
